import { db } from "../../firebase";
import moment from "moment";

/**
 * Writes granular change records to the `micro-activity` Firestore collection.
 * Each detail string becomes its own document for easy table filtering.
 */
export function log_micro_activity({
  playerID = null,
  playerName = "",
  section = "",
  action = "updated",
  details = [],
  editor = "Unknown User",
  editorUID = null,
}) {
  const detailList = (Array.isArray(details) ? details : [details]).filter(Boolean);
  if (!detailList.length) return Promise.resolve();

  const timestamp = moment().unix();
  const batch = db.batch();

  detailList.forEach((detail) => {
    const ref = db.collection("micro-activity").doc();
    batch.set(ref, {
      timestamp,
      playerID,
      playerName,
      section,
      action,
      detail,
      editor,
      editorUID,
    });
  });

  return batch.commit().catch((error) => {
    console.error("Micro activity logging failed:", error);
  });
}
